import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Helmet } from 'react-helmet'
import { Tabs } from 'antd'
import { Link } from 'react-router-dom'
import IndividualAccountsAction from 'redux/singleaccounts/actions'
import AccountDetail from './AccountDetail'
import NotesInfo from './NotesInfo'
import Invoices from './Invoices'
import Enquiry from './Enquiry'
import DailyReports from './Daily-Reports'
import Services from './Services'
import Renewals from './Renewals'
import Receipts from './Receipts'
import Ledger from './Ledger'

const { TabPane } = Tabs

const mapStateToProps = ({ dispatch, singleaccounts }) => ({
  dispatch,
  singleaccounts,
})

const StoreInfo = ({ dispatch, singleaccounts, intl: { formatMessage } }) => {
  const path = window.location.pathname
  const userId = path.replace('/manage/accounts/', '')

  const AccountDatas = singleaccounts?.IndividualAccountData

  useEffect(() => {
    dispatch({
      type: IndividualAccountsAction.LOAD_SINGLE_ACCOUNTS,
      payload: {
        accountsId: userId,
      },
    })
  }, [dispatch, userId])

  const query = new URLSearchParams(window.location.search)
  const tabname = query.get('tab')

  let tabUrlVal

  if (tabname === 'accounts-info') {
    tabUrlVal = '1'
  } else if (tabname === 'notes') {
    tabUrlVal = '2'
  } else if (tabname === 'invoices') {
    tabUrlVal = '3'
  } else if (tabname === 'enquiry') {
    tabUrlVal = '4'
  } else if (tabname === 'daily-reports') {
    tabUrlVal = '5'
  } else if (tabname === 'services') {
    tabUrlVal = '6'
  } else if (tabname === 'renewals') {
    tabUrlVal = '7'
  } else if (tabname === 'receipts') {
    tabUrlVal = '8'
  } else if (tabname === 'ledger') {
    tabUrlVal = '9'
  }

  return (
    <div>
      <Helmet
        title={formatMessage({
          id: 'title.helmet.accounts',
        })}
      />
      <div className="row">
        <div className="col-md-6">
          <h5 className="mb-4">
            <strong>{AccountDatas?.business_name}</strong>
          </h5>
        </div>
      </div>
      <Tabs defaultActiveKey={tabUrlVal}>
        <TabPane
          tab={
            <Link to="?tab=accounts-info">
              <span>{formatMessage({ id: 'text.storeino.tab.accountsInfo' })}</span>
            </Link>
          }
          key={1}
        >
          <AccountDetail apiRes={AccountDatas} />
        </TabPane>
        <TabPane
          tab={
            <Link to="?tab=notes">
              <span>{formatMessage({ id: 'text.storeino.tab.notesInfo' })}</span>
            </Link>
          }
          key={2}
        >
          <NotesInfo />
        </TabPane>

        <TabPane
          tab={
            <Link to="?tab=invoices">
              <span>{formatMessage({ id: 'text.storeino.tab.invoices' })}</span>
            </Link>
          }
          key={3}
        >
          <Invoices />
        </TabPane>
        <TabPane
          tab={
            <Link to="?tab=enquiry">
              <span>{formatMessage({ id: 'text.storeino.tab.enquiry' })}</span>
            </Link>
          }
          key={4}
        >
          <Enquiry />
        </TabPane>
        <TabPane
          tab={
            <Link to="?tab=daily-reports">
              <span>{formatMessage({ id: 'text.storeino.tab.dailyReports' })}</span>
            </Link>
          }
          key={5}
        >
          <DailyReports />
        </TabPane>
        <TabPane
          tab={
            <Link to="?tab=services">
              <span>{formatMessage({ id: 'text.storeino.tab.services' })}</span>
            </Link>
          }
          key={6}
        >
          <Services />
        </TabPane>
        <TabPane
          tab={
            <Link to="?tab=renewals">
              <span>{formatMessage({ id: 'text.storeino.tab.renewals' })}</span>
            </Link>
          }
          key={7}
        >
          <Renewals />
        </TabPane>
        <TabPane
          tab={
            <Link to="?tab=receipts">
              <span>{formatMessage({ id: 'text.storeino.tab.receipts' })}</span>
            </Link>
          }
          key={8}
        >
          <Receipts />
        </TabPane>
        <TabPane
          tab={
            <Link to="?tab=ledger">
              <span>{formatMessage({ id: 'text.storeino.tab.ledger' })}</span>
            </Link>
          }
          key={9}
        >
          <Ledger />
        </TabPane>
      </Tabs>
    </div>
  )
}

export default connect(mapStateToProps)(injectIntl(StoreInfo))
